/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import { useFieldArray, useForm, Controller } from "react-hook-form";
import {
  Flex,
  Button,
  FormControl,
  FormLabel,
  Checkbox,
} from "@chakra-ui/react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { MdDeleteSweep } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import FormInput from "components/forms/form-Input";
import NumericInput from "components/forms/react-hook-numeric-input";
import { useLookupCurrencyMultiples } from "services/lookups-mutations";
import ReactHookFormDropdown from "components/forms/react-hook-dropdown";
import { isDenominationMixed } from "pages/servicePoints/utils";

const CASSETTES_DEFAULT = {
  description: "",
  denomination: "Multiple",
  currency: "",
  multiple: "",
  cassetteType: "",
  maker: "",
  limit: 0,
  dualScanning: true,
};
const CASSETTES_DESCRIPTIONS = [
  "ATM Cassette",
  "CDM Cassette",
  "ATM Reject Bin",
  "CDM Cash Bin",
];
const CASSETTES_TYPE = [
  "Type 1",
  "Type 2",
  "Type 3",
  "Type 4",
  "Type 5",
  "Type 6",
  "Cash Bin",
  "Reject Bin",
];

export default function CassettesForm({
  addData,
  cassettes,
  currencies,
  disabled,
}) {
  const [currentEditing, setCurrentEditing] = useState(null);
  const {
    mutate: getMultiples,
    data: multipleList,
    reset: cassetteMultipleReset,
  } = useLookupCurrencyMultiples();

  const {
    handleSubmit,
    getValues,
    watch,
    control,
    reset,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      ...CASSETTES_DEFAULT,
      cassettes: [...cassettes],
    },
  });
  const generalFieldProps = { control, errors };
  const formValidationRules = {
    description: { required: "Please add description" },
    denomination: { required: "Please add denomination" },
    cassetteType: { required: "Please select cassette type" },
    maker: { required: "Please add maker" },
    limit: {
      validate: (value) => {
        if (
          (!isDenominationMixed(watch("description")?.id) && !value) ||
          value === "0"
        ) {
          return "Please Enter Limit";
        }
        // eslint-disable-next-line no-else-return
        else {
          return true;
        }
      },
    },
  };
  const { fields: cassettesFields, remove: cassettesFieldsRemove } =
    useFieldArray({
      control: generalFieldProps.control,
      name: "cassettes",
    });
  useEffect(() => {
    if (addData) addData([...cassettesFields]);
  }, [cassettesFields]);

  useEffect(() => {
    cassetteMultipleReset();
    const _currency = watch("currency");
    if (_currency && _currency.shortName !== "0") {
      getMultiples(watch("currency").shortName);
    }
  }, [watch("currency")]);

  useEffect(() => {
    if (watch("multiple")) {
      setValue(
        "denomination",
        `${watch("currency")?.shortName || ""} ${watch("multiple")?.text || ""}`
      );
      clearErrors("denomination");
    }
  }, [watch("multiple")]);

  const onCurrencyDescriptionChange = (e) => {
    const _value = e.target.value.id;
    setValue("currency", "");
    setValue("multiple", "");
    if (!isDenominationMixed(_value)) {
      setValue("denomination", "");
    } else {
      setValue("limit", 0);
      setValue("denomination", "Mixed");
      if (_value === "ATM Reject Bin") {
        setValue("cassetteType", { id: "Reject Bin", text: "Reject Bin" });
      } else if (_value === "CDM Cash Bin") {
        setValue("cassetteType", { id: "Cash Bin", text: "Cash Bin" });
      }
    }
  };
  const onCurrencyChange = () => {
    cassetteMultipleReset();
    setValue("multiple", "");
  };
  const submitInfo = (data) => {
    const _cassettes = [...cassettesFields];
    const newCassette = {
      description: data.description,
      denomination: data.denomination,
      currency: data.currency,
      multiple: data.multiple,
      cassetteType: data.cassetteType,
      maker: data.maker,
      limit: data.limit,
      dualScanning: data.dualScanning,
    };
    if (currentEditing !== null) {
      _cassettes[currentEditing] = newCassette;
      setCurrentEditing(null);
    } else {
      _cassettes.push(newCassette);
    }
    reset({
      ...CASSETTES_DEFAULT,
      cassettes: [..._cassettes],
    });
  };

  const editCell = ({ dataItem, dataIndex }) => {
    return (
      <td>
        <Flex
          title="Edit Cassette"
          cursor="pointer"
          onClick={() => {
            reset({
              ...getValues(),
              ...dataItem,

              cassettes: [...cassettesFields],
            });
            setCurrentEditing(dataIndex);
          }}
        >
          <FaEdit fontSize="18px" color="var(--primary-dark)" />
        </Flex>
      </td>
    );
  };

  const deleteCell = ({ dataIndex }) => {
    return (
      <td>
        <Flex
          title="Delete Cassette"
          cursor="pointer"
          onClick={() => {
            cassettesFieldsRemove(dataIndex);
          }}
        >
          <MdDeleteSweep fontSize="18px" color="red" />
        </Flex>
      </td>
    );
  };
  const cancelEditing = () => {
    reset({
      ...CASSETTES_DEFAULT,
      cassettes: [...cassettesFields],
    });
    setCurrentEditing(null);
  };

  const getCassettesDescriptions = useMemo(() => {
    return CASSETTES_DESCRIPTIONS.map((elm) => ({ id: elm, text: elm }));
  }, [CASSETTES_DESCRIPTIONS]);
  const getCassetteTypes = useMemo(() => {
    return CASSETTES_TYPE.map((elm) => ({ id: elm, text: elm }));
  }, [CASSETTES_TYPE]);
  return (
    <form>
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Description"
        name="description"
        id="id"
        text="text"
        data={getCassettesDescriptions}
        placeholder="Select Description"
        rules={formValidationRules.description}
        onChange={onCurrencyDescriptionChange}
        disabled={disabled}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Currency"
        name="currency"
        id="shortName"
        text="name"
        data={currencies || []}
        placeholder="Select Currency"
        rules={formValidationRules.currency}
        onChange={onCurrencyChange}
        dropdownProps={{ filterable: true }}
        disabled={disabled || isDenominationMixed(watch("description")?.id)}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Multiple"
        name="multiple"
        id="id"
        text="text"
        data={
          multipleList?.data.map((elm) => ({
            id: elm.multiple,
            text: elm.multiple,
          })) || []
        }
        placeholder="Select Multiple"
        rules={formValidationRules.multiple}
        dropdownProps={{ filterable: true }}
        disabled={
          disabled ||
          !watch("currency") ||
          isDenominationMixed(watch("description")?.id)
        }
      />
      <FormInput
        {...generalFieldProps}
        isRequired
        name="denomination"
        label="Denomination"
        rules={formValidationRules.denomination}
        inputProps={{ readOnly: true }}
      />

      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Cassette Type"
        name="cassetteType"
        id="id"
        text="text"
        data={getCassetteTypes}
        placeholder="Select Cassette Type"
        rules={formValidationRules.cassetteType}
        dropdownProps={{ filterable: false }}
        disabled={disabled || isDenominationMixed(watch("description")?.id)}
      />

      <FormInput
        {...generalFieldProps}
        isRequired
        label="Maker"
        rules={formValidationRules.maker}
        name="maker"
        disabled={disabled}
      />
      <NumericInput
        {...generalFieldProps}
        isRequired
        label="Limit"
        rules={formValidationRules.limit}
        name="limit"
        disabled={disabled}
      />

      <div style={{ width: "100%" }} />
      <FormControl>
        <Controller
          control={generalFieldProps.control}
          name="dualScanning"
          render={({ field }) => {
            return (
              <Checkbox
                isChecked={field.value}
                onChange={field.onChange}
                disabled={disabled}
              >
                <FormLabel style={{ margin: 0 }}>Dual Scanning</FormLabel>
              </Checkbox>
            );
          }}
        />
      </FormControl>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          gap: "16px",
        }}
      >
        {currentEditing !== null ? (
          <Button onClick={cancelEditing} disabled={disabled}>
            Cancel
          </Button>
        ) : (
          <></>
        )}
        <Button
          type="button"
          disabled={disabled}
          onClick={handleSubmit(submitInfo)}
        >
          {currentEditing !== null ? "Update Cassette" : "Add Cassette"}
        </Button>
      </div>
      <div style={{ width: "100%" }} />

      <Grid data={cassettesFields} style={{ width: "100%" }}>
        <GridColumn field="description.id" title="Description" />
        <GridColumn Title="Denomination" field="denomination" />
        <GridColumn title="Cassette type" field="cassetteType.text" />
        <GridColumn title="Maker" field="maker" />
        <GridColumn title="Limit" field="limit" />
        <GridColumn
          title="Dual Scanning"
          cell={({ dataItem }) => (
            <td>
              <Checkbox isChecked={dataItem.dualScanning} />
            </td>
          )}
        />
        <GridColumn title="Edit" cell={editCell} width={120} />
        <GridColumn title="Delete" cell={deleteCell} width={120} />
      </Grid>
    </form>
  );
}
